import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Input, InputNumber, Row, Form } from 'antd';
import { VDSRequestResultModal } from '../../containers';
import {
  STATISTICS_TYPE_GHG,
  STATISTICS_TYPE_VDS,
} from '../../constants/StatisticsTypes';
import { getStatisticsTypeOptions } from '../../utils/vdsHelpers';
import RadioGroup from '../../atoms/RadioGroup';
import { v4 as uuidv4 } from 'uuid';

const typeOptions = getStatisticsTypeOptions();

export class VDSSalesCancellationForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onReset: PropTypes.func,
    children: PropTypes.any,
    request: PropTypes.any,
    response: PropTypes.any,
    data: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      type: STATISTICS_TYPE_VDS,
      resultsModalShown: false,
    };
  }

  componentDidMount() {
    const { data } = this.props;
    if (data) {
      const values = {};
      let isGHG = false;
      if (data.OfferID) {
        values.OfferSource = { OfferID: data.OfferID };
        if (
          data.OfferType &&
          data.OfferType.GHG &&
          data.OfferType.GHG.GHGAmount
        ) {
          values.Cancelled = {
            GHGAmount: data.OfferType.GHG.GHGAmount,
          };
          isGHG = true;
        } else if (
          data.OfferType &&
          data.OfferType.Energy &&
          data.OfferType.Energy.QuantityEnergyNatural
        ) {
          values.Cancelled = {
            QuantityEnergyNatural2: data.OfferType.Energy.QuantityEnergyNatural,
          };
        }
      } else if (data.SourceID) {
        values.OfferSource = { SourceID: data.SourceID };
        if (
          data.OfferType &&
          data.OfferType.Energy &&
          data.OfferType.Energy.QuantityEnergyNatural
        ) {
          values.Cancelled = {
            QuantityEnergyNatural: data.OfferType.Energy.QuantityEnergyNatural,
          };
        }
      }
      if (isGHG) {
        this.setState({ type: STATISTICS_TYPE_GHG }, () =>
          this.setValues(values)
        );
      } else {
        this.setValues(values);
      }
    }
    this.resetCancelID();
  }

  resetCancelID() {
    this.formRef.current?.setFieldsValue({ CancelID: uuidv4() });
  }

  setValues(values) {
    this.formRef.current?.setFieldsValue(values);
  }

  isFirstMarketSale() {
    const values = this.formRef.current?.getFieldsValue() || {};

    return (
      !!values.OfferSource?.SourceID ||
      !!values.Cancelled?.QuantityEnergyNatural
    );
  }

  isSecondMarketSale() {
    const values = this.formRef.current?.getFieldsValue() || {};

    return (
      !!values.OfferSource?.OfferID ||
      !!values.Cancelled?.GHGAmount ||
      !!values.Cancelled?.QuantityEnergyNatural2
    );
  }

  submit = () => {
    this.formRef.current?.validateFields().then((values) => {
      this.props.onSubmit?.(values);
    });
  };

  reset = () => {
    this.formRef.current?.resetFields();
    this.resetCancelID();
    this.props.onReset?.();
  };

  onTypeChange = (event) => {
    this.setState({ type: event.target.value });
  };

  showResult = () => {
    this.setState({ resultsModalShown: true });
  };

  hideResult = () => {
    this.setState({ resultsModalShown: false });
  };

  render() {
    const { children, request, response } = this.props;
    const { type, resultsModalShown } = this.state;
    const firstMarketSale = this.isFirstMarketSale();
    const secondMarketSale = this.isSecondMarketSale();

    return (
      <Form
        ref={this.formRef}
        onFinish={this.submit}
        layout="vertical"
        onValuesChange={() => this.forceUpdate()}
      >
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="CancelID"
              name="CancelID"
              rules={[
                { required: true, message: 'Sisesta CancelID' },
                { max: 50, message: 'Maksimaalne pikkus on 50' },
              ]}
            >
              <Input placeholder="CancelID" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <h2>Esimese turu müük</h2>
            <div className="block">
              {!secondMarketSale ? (
                <Form.Item
                  key="SourceID"
                  label="OfferSource"
                  name={['OfferSource', 'SourceID']}
                  rules={[
                    { required: true, message: 'Sisesta OfferSource SourceID' },
                    { max: 50, message: 'Maksimaalne pikkus on 50' },
                  ]}
                >
                  <Input placeholder="SourceID" />
                </Form.Item>
              ) : (
                <Form.Item key="SourceID_" label="OfferSource">
                  <Input placeholder="SourceID" disabled />
                </Form.Item>
              )}
              {!secondMarketSale ? (
                <Form.Item
                  key="QuantityEnergyNatural"
                  label="Cancelled"
                  name={['Cancelled', 'QuantityEnergyNatural']}
                  rules={[
                    {
                      required: true,
                      message: 'Sisesta Cancelled QuantityEnergyNatural',
                    },
                  ]}
                >
                  <InputNumber
                    className="w-100"
                    min={0.1}
                    max={99999999999999.9}
                    step={0.1}
                    precision={1}
                    placeholder="QuantityEnergyNatural (MJ)"
                  />
                </Form.Item>
              ) : (
                <Form.Item key="QuantityEnergyNatural_" label="Cancelled">
                  <InputNumber
                    className="w-100"
                    placeholder="QuantityEnergyNatural (MJ)"
                    disabled
                  />
                </Form.Item>
              )}
            </div>
          </Col>
          <Col span={12}>
            <h2>Teise turu müük</h2>
            <div className="block">
              {!firstMarketSale ? (
                <Form.Item
                  key="OfferID"
                  label="OfferSource"
                  name={['OfferSource', 'OfferID']}
                  rules={[
                    { required: true, message: 'Sisesta OfferSource OfferID' },
                    { max: 50, message: 'Maksimaalne pikkus on 50' },
                  ]}
                >
                  <Input placeholder="OfferID" />
                </Form.Item>
              ) : (
                <Form.Item key="OfferID_" label="OfferSource">
                  <Input placeholder="OfferID" disabled />
                </Form.Item>
              )}
              <Form.Item label="Source type">
                <RadioGroup
                  options={typeOptions}
                  valueKey="value"
                  labelKey="name"
                  value={type}
                  disabled={firstMarketSale}
                  onChange={this.onTypeChange}
                />
              </Form.Item>
              {firstMarketSale && (
                <Form.Item key="Cancelled_" label="Cancelled">
                  <InputNumber
                    className="w-100"
                    disabled
                    placeholder={
                      type === STATISTICS_TYPE_GHG
                        ? 'GHGAmount (t)'
                        : 'QuantityEnergyNatural (MJ)'
                    }
                  />
                </Form.Item>
              )}
              {!firstMarketSale && type === STATISTICS_TYPE_GHG && (
                <Form.Item
                  key="Cancelled"
                  label="Cancelled"
                  name={['Cancelled', 'GHGAmount']}
                  rules={[
                    {
                      required: true,
                      message: 'Sisesta Cancelled GHGAmount',
                    },
                  ]}
                >
                  <InputNumber
                    className="w-100"
                    min={-99999999999999.9}
                    max={-0.1}
                    step={0.1}
                    precision={1}
                    disabled={firstMarketSale}
                    placeholder="GHGAmount (t)"
                  />
                </Form.Item>
              )}
              {!firstMarketSale && type === STATISTICS_TYPE_VDS && (
                <Form.Item
                  key="Cancelled"
                  label="Cancelled"
                  name={['Cancelled', 'QuantityEnergyNatural2']}
                  rules={[
                    {
                      required: true,
                      message: 'Sisesta Cancelled QuantityEnergyNatural',
                    },
                  ]}
                >
                  <InputNumber
                    className="w-100"
                    min={0.1}
                    max={99999999999999.9}
                    step={0.1}
                    precision={1}
                    disabled={firstMarketSale}
                    placeholder="QuantityEnergyNatural (MJ)"
                  />
                </Form.Item>
              )}
            </div>
          </Col>
        </Row>
        <Row>
          <Col className="form-footer">
            <Button htmlType="submit" type="primary">
              Saada
            </Button>
            <Button onClick={this.reset}>Puhasta</Button>
            <Button onClick={this.showResult} disabled={!request}>
              Päringu tulemus
            </Button>
          </Col>
        </Row>
        {children}
        <VDSRequestResultModal
          request={request}
          response={response}
          show={resultsModalShown}
          hideModal={this.hideResult}
        />
      </Form>
    );
  }
}

export default VDSSalesCancellationForm;
